<template>
  <div class="in-modal">
    <modal
      name="news"
      transition="nice-modal-fade"
      :min-width="200"
      :min-height="200"
      :pivot-y="0.5"
      :adaptive="true"
      :scrollable="true"
      :reset="true"
      width="80%"
      height="auto"
    >
      <div class="header">
        <h1>
          {{ $t("message.news") }}
          <span>
            <button
            class="btn btn-link"
            style="font-size: 30px;color: white;float: right;padding: 0px;position: relative;bottom: 3px;"
            @click="hide('news')"><i class="fa fa-window-close" style="font-size: 38px;"></i></button>
            <button
              style="float: right;margin-right: 20px;width: 44px;font-size: 5px;color: #d7a003;background: white none repeat scroll 0% 0%;border-radius: 5px;"
              class="btn btn-primary btn-block"
              @click="download('news')"
            >
              <i class="fa fa-file-pdf" style="font-size: 22px;"></i><!--&nbsp;&nbsp;pdf-->
            </button>
          </span>
        </h1>
      </div>

      <div class="content row">
        <div v-if="news_products_grouped.length" class="lista_produktow">
          <div v-for="group in news_products_grouped" :key="group.label">

            <!-- Nagłówek miesiąca -->
            <div class="month-header">
              <!-- 📅  -->
              <i class="fa fa-calendar" aria-hidden="true"></i> {{ group.label }}
            </div>

            <!-- Produkty w danym miesiącu -->
            <ul>
              <li v-for="product in group.products" :key="product.data.code">
                <button
                  v-scroll-to="{ el: `#` + to_slug(product.data.code), onStart: onStart }"
                  class="btn btn-link"
                  style="text-decoration:none; font-size:16px; padding:2px; width:100%; text-align:left;"
                >
                  <div class="col1">
                    <b>{{ product.data.code }}</b> -
                    <span style="font-size:12px">{{ product.data.name }}</span>
                  </div>
                  <div class="col2">
                    <span style="font-size:12px;">{{ $t("message.show_product") }}</span>
                  </div>
                  <div class="col3">
                    <Price :product="product"/>
                  </div>
                </button>
              </li>
            </ul>

          </div>
        </div>

        <!-- <div class="col-lg-12 col-md-12 col-sm-12 columns">
          <ul v-if="news_products_uniq.length" class="lista_produktow">
            <li v-for="product in news_products_uniq" :key="product.data.code">
              <button v-scroll-to="{ el: `#`+to_slug(product.data.code), onStart: onStart, }"
              class='btn btn-link'
              style="text-decoration:none; font-size: 16px;padding: 2px; width:100%;text-align: left;">
              <div class="col1"><b>{{product.data.code}}</b> - <span style="font-size: 12px">{{product.data.name}}</span></div>
              <div class="col2"><span style="font-size: 12px;">{{ $t("message.show_product") }}</span></div>
              <div class="col3"><Price :product="product"/></div>
              </button>
            </li>
          </ul>
          <ul v-else>
            <li>{{ $t('message.no_results_news') }}</li>
          </ul>
        </div> -->

        <!-- <div class="col-lg-12 buttons">
          <button class="btn btn-default" @click="hide('news')">{{ $t("message.close") }}</button>
        </div> -->
      </div>
    </modal>
    <button
      class="btn btn-primary btn-block btnRight"
      @click="show('news')"
    >{{ $t("message.news") }}</button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { helpers } from "../mixins/helpers";
import Price from "../Product/Price.vue";

export default {
  mixins: [helpers],
  components: {
    Price
  },
  methods: {
    show(name) {
      this.$modal.show(name);
    },
    hide(name) {
      this.$modal.hide(name);
    },
    onStart() {
      this.hide("news");
    }
  },
  computed: {
     ...mapGetters('pricelist', ['listType','products']),
    news_products() {
      let productsList = this.products // this.$store.getters["pricelist/products"];
      let typeList = (this.listType == 'mw') ? 'Mean Well' : 'Pulsar'
      return Object.values(productsList).filter(item => {
      // return products.filter(item => {
        return (item.data && item.data.price && item.data.price.new && item.data.producer == typeList) ? item.data.price.new : null;
      });
    },
    news_products_sort() {
      return [...this.news_products].sort((a, b) => {
        // Najpierw po dacie startData (od najnowszych)
        const dateA = new Date(a.data.startData);
        const dateB = new Date(b.data.startData);
        if (dateB - dateA !== 0) return dateB - dateA;
        // Potem po code alfabetycznie
        return a.data.code > b.data.code ? 1 : -1;
      });
    },

    news_products_uniq() {
      const seen = new Set();
      return this.news_products_sort.filter(product => {
        if (seen.has(product.data.code)) return false;
        seen.add(product.data.code);
        return true;
      });
    },

    news_products_grouped() {
      const groups = {};

      this.news_products_uniq.forEach(product => {
        const date = new Date(product.data.startData);
        // Klucz do sortowania: "2026-02"
        const key = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
        // Etykieta wyświetlana: "Luty 2026"
        const label = date.toLocaleDateString('pl-PL', { month: 'long', year: 'numeric' });

        if (!groups[key]) {
          groups[key] = { label, products: [] };
        }
        groups[key].products.push(product);
      });

      // Posortuj grupy od najnowszej
      return Object.keys(groups)
        .sort((a, b) => b.localeCompare(a))
        .map(key => groups[key]);
    },
    // news_products_sort() {
    //   //return this.sales_products;
    //   console.log(this.news_products)
    //   return this.news_products.sort((a, b) =>
    //     a.data.code > b.data.code ? 1 : -1
    //   );
    // },
    // news_products_uniq() {
    //   var Remove_duplicate_Value = [];
    //   var obj_products = [];
    //   for (var i = 0; i < this.news_products_sort.length; i++) {
    //     if (
    //       Remove_duplicate_Value.indexOf(
    //         this.news_products_sort[i].data.code
    //       ) === -1
    //     ) {
    //       Remove_duplicate_Value.push(this.news_products_sort[i].data.code);
    //       obj_products.push(this.news_products_sort[i]);
    //     }
    //   }
    //   return obj_products;
    // }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.month-header {
  background-color: #f0f4f8;
  padding: 8px 12px;
  font-weight: bold;
  font-size: 15px;
  border-left: 4px solid #3b82f6;
  margin-top: 16px;
  margin-bottom: 4px;
  text-transform: capitalize; /* "luty 2026" → "Luty 2026" */
}


@color: #d7a003;

.in-modal {
  h1 {
    margin-bottom: 0;
    font-size: 1.4em;
  }
  .content {
    padding: 15px 30px;
    .separator {
      select {
        font-size: 0.8em;
        option {
          -webkit-appearance: none;
          -moz-appearance: none;
          appearance: none;
          padding: 15px 0;
        }
      }
    }
  }
  .header {
    background: @color;
    padding: 15px 30px;
    color: #fff;
  }
  .form-check {
    padding-left: 2.25rem;
    .form-check-label {
      font-size: 0.8em;
    }
  }
  .buttons {
    margin-top: 30px;
    text-align: right;
  }
}

.col2{
  float: inline-end;
  margin-left: 20px;
}
.col3 {
    float: inline-end;
}
.lista_produktow {
  width:100%
}
.lista_produktow li:hover{
  background: #f2f2f2;
  padding: 0px 5px;
}

.btn-primary,
.btn-primary:not(:disabled):not(.disabled).active,
.btn-primary:not(:disabled):not(.disabled):active,
.show > .btn-primary.dropdown-toggle {
  background: @color;
  color: #fff;
  border-color: @color;
}
.btn-primary {
  background: @color;
  color: #fff;
  border-color: @color;
  font-weight: 400;
  min-width: 85px;
}
ul {
  font-size: 0.8em;
  padding-left: 15px;
  li {
    margin: 0 0 4px 0;
    div {
      display: inline;
    }
    a {
      cursor: pointer;
      color: inherit;
      &:hover {
        text-decoration: underline;
      }
    }
    button {
      font-size: 0.8em;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/News/News.vue